interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionText?: string;
  onAction?: () => void;
}

export default function EmptyState({ icon = 'ri-inbox-line', title, description, actionText, onAction }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 md:py-20 text-center animate-fade-up">
      <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 text-4xl mb-5">
        <i className={icon}></i>
      </div>
      <h3 className="text-base font-semibold text-foreground-800">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>}
      {actionText && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 px-5 py-2.5 text-sm rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {actionText}
        </button>
      )}
    </div>
  );
}